// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────
   GameViewportModal — Cluster 1 modal primitive
   ──────────────────────────────────────────
   Base classes the primitive renders. Consumers append a variant suffix
   (e.g. gvm-overlay--player-shop) so each modal can override the
   palette without re-implementing the geometry. See modal-canon for
   the cluster-1 contract — portal into \`.deck-map-area\`, scrim is
   intra-viewport not full-page, sidebar/exam-tabs-bar/BLS chrome stays
   visible behind the scrim.
   ────────────────────────────────────────── */

.gvm-viewport {
  position: absolute;
  inset: 0;
  z-index: 100;
  container-type: inline-size;
}

body > .gvm-viewport {
  position: fixed;
}

.gvm-overlay {
  position: absolute;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.04) 0%, rgba(0, 0, 0, 0.45) 70%);
  backdrop-filter: blur(4px) saturate(1.05);
  -webkit-backdrop-filter: blur(4px) saturate(1.05);
  animation: gvm-scrim-in 0.18s ease-out;
}

/* When the modal falls back to mounting on document.body (e.g. because
   \`.deck-map-area\` wasn't ready) cover the full viewport so the modal
   still works rather than rendering invisibly behind the dashboard. */
body > .gvm-overlay {
  position: fixed;
}

.gvm-body {
  position: relative;
  width: 100%;
  height: 100%;
  background:
    linear-gradient(135deg, rgba(20, 20, 28, 0.55) 0%, rgba(14, 14, 22, 0.45) 100%);
  border: 1px solid rgba(255, 255, 255, 0.10);
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.04),
    0 24px 60px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px) saturate(1.15);
  -webkit-backdrop-filter: blur(8px) saturate(1.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: gvm-panel-in 0.22s cubic-bezier(0.34, 1.2, 0.5, 1);
}

@keyframes gvm-scrim-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes gvm-panel-in {
  from { opacity: 0; transform: scale(0.97) translateY(6px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.gvm-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 5;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(0, 0, 0, 0.55);
  color: rgba(243, 244, 246, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, transform 0.15s ease;
}

.gvm-close:hover {
  background: rgba(0, 0, 0, 0.78);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.32);
  transform: scale(1.06);
}

.gvm-close:active {
  transform: scale(0.94);
}

.gvm-close svg {
  width: 18px;
  height: 18px;
}

.gvm-content {
  position: relative;
  z-index: 2;
  flex: 1 1;
  overflow: auto;
  min-height: 0;
}

.gvm-content::-webkit-scrollbar {
  width: 8px;
}
.gvm-content::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.18);
}
.gvm-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 4px;
}
.gvm-content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.28);
}

@media (prefers-reduced-motion: reduce) {
  .gvm-overlay,
  .gvm-body {
    animation: none;
  }
}

@container (max-width: 1800px) {
  .gvm-overlay {
    padding: clamp(16px, 1.2cqi, 24px);
  }

  .gvm-close {
    top: clamp(8px, 0.75cqi, 12px);
    right: clamp(8px, 0.75cqi, 12px);
    width: max(32px, clamp(28px, 2cqi, 32px));
    height: max(32px, clamp(28px, 2cqi, 32px));
  }

  .gvm-close svg {
    width: clamp(16px, 1cqi, 18px);
    height: clamp(16px, 1cqi, 18px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GameViewportModal/GameViewportModal.css"],"names":[],"mappings":"AAAA;;;;;;;;;+CAS+C;;AAE/C;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb;6FAC2F;EAC3F,yCAAyC;EACzC,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;;sEAEsE;AACtE;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;mFACiF;EACjF,2CAA2C;EAC3C;;kCAEgC;EAChC,yCAAyC;EACzC,iDAAiD;EACjD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kGAAkG;AACpG;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;IAChC,yCAAyC;IACzC,0CAA0C;EAC5C;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;AACF","sourcesContent":["/* ──────────────────────────────────────────\n   GameViewportModal — Cluster 1 modal primitive\n   ──────────────────────────────────────────\n   Base classes the primitive renders. Consumers append a variant suffix\n   (e.g. gvm-overlay--player-shop) so each modal can override the\n   palette without re-implementing the geometry. See modal-canon for\n   the cluster-1 contract — portal into `.deck-map-area`, scrim is\n   intra-viewport not full-page, sidebar/exam-tabs-bar/BLS chrome stays\n   visible behind the scrim.\n   ────────────────────────────────────────── */\n\n.gvm-viewport {\n  position: absolute;\n  inset: 0;\n  z-index: 100;\n  container-type: inline-size;\n}\n\nbody > .gvm-viewport {\n  position: fixed;\n}\n\n.gvm-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background:\n    radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.04) 0%, rgba(0, 0, 0, 0.45) 70%);\n  backdrop-filter: blur(4px) saturate(1.05);\n  -webkit-backdrop-filter: blur(4px) saturate(1.05);\n  animation: gvm-scrim-in 0.18s ease-out;\n}\n\n/* When the modal falls back to mounting on document.body (e.g. because\n   `.deck-map-area` wasn't ready) cover the full viewport so the modal\n   still works rather than rendering invisibly behind the dashboard. */\nbody > .gvm-overlay {\n  position: fixed;\n}\n\n.gvm-body {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background:\n    linear-gradient(135deg, rgba(20, 20, 28, 0.55) 0%, rgba(14, 14, 22, 0.45) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.04),\n    0 24px 60px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(8px) saturate(1.15);\n  -webkit-backdrop-filter: blur(8px) saturate(1.15);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: gvm-panel-in 0.22s cubic-bezier(0.34, 1.2, 0.5, 1);\n}\n\n@keyframes gvm-scrim-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes gvm-panel-in {\n  from { opacity: 0; transform: scale(0.97) translateY(6px); }\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.gvm-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 5;\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(0, 0, 0, 0.55);\n  color: rgba(243, 244, 246, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, transform 0.15s ease;\n}\n\n.gvm-close:hover {\n  background: rgba(0, 0, 0, 0.78);\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.32);\n  transform: scale(1.06);\n}\n\n.gvm-close:active {\n  transform: scale(0.94);\n}\n\n.gvm-close svg {\n  width: 18px;\n  height: 18px;\n}\n\n.gvm-content {\n  position: relative;\n  z-index: 2;\n  flex: 1;\n  overflow: auto;\n  min-height: 0;\n}\n\n.gvm-content::-webkit-scrollbar {\n  width: 8px;\n}\n.gvm-content::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.18);\n}\n.gvm-content::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 4px;\n}\n.gvm-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.28);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .gvm-overlay,\n  .gvm-body {\n    animation: none;\n  }\n}\n\n@container (max-width: 1800px) {\n  .gvm-overlay {\n    padding: clamp(16px, 1.2cqi, 24px);\n  }\n\n  .gvm-close {\n    top: clamp(8px, 0.75cqi, 12px);\n    right: clamp(8px, 0.75cqi, 12px);\n    width: max(32px, clamp(28px, 2cqi, 32px));\n    height: max(32px, clamp(28px, 2cqi, 32px));\n  }\n\n  .gvm-close svg {\n    width: clamp(16px, 1cqi, 18px);\n    height: clamp(16px, 1cqi, 18px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
